import React from 'react'

//the options for type are success, warning, error, & info
//if you need paragraph width provide paragraph prop
//heading and text are optional
export const LgyAlertDialog = ({ type, heading, text, paragraph, children, id }) =>
  <div id={id} className={`lgy-alert usa-alert usa-alert-${type} usa-alert--${type} ${paragraph ? 'usa-alert-paragraph usa-alert__paragraph' : ''}`} role='alert'>
    <div className='usa-alert-body usa-alert__body'>
      <h3 className='usa-alert-heading usa-alert__heading'>
        {heading}
      </h3>
      <div className='usa-alert-text usa-alert__text'>
        {text}
        {children}
      </div>
    </div>
  </div>

export default LgyAlertDialog
